import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { ResourceOperationEfficiencyLog } from "./resource-op-efficiency-log.entity";
@Entity('resource_operation_efficiency')
export class resourceOperationEfficiency {

  @PrimaryGeneratedColumn("increment",{name:'resource_operation_efficiency_id'})
  resourceOperationEfficiencyId:number;

  @Column("char",{
      nullable:false,
      length:50,
      name:"variant_code"
      })
  // @Index({ unique: true })
  variantCode:string;
  @Column("varchar", {
    nullable: false,
    name: "operation",
  })
  operation: string;
  @Column("int",{
    name:"min_count",
    default:0
    })
  minCount:number;
  @Column("int",{
   name:"max_count",
   default:0
  })
  maxCount:number;
  @Column("int",{
    nullable:false,
    name:"efficiency",
    default:0
    })
  efficiency:number;
  @Column("int",{
    nullable:false,
    name:"hrs_per_shift",
    default:8
    })
  hrsPerShift:number;
  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      default:1,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  // @OneToMany(type => ResourceOperationEfficiencyLog, effLogs => effLogs.resourceOpInfo, { cascade: true })
  // effLogsInfo: ResourceOperationEfficiencyLog[];


}
